export default class ResponsiveBackground {

    constructor() {
        this.init();
    }

    init() {

        this.responsiveBg = document.querySelectorAll(".js-responsive-background");

        if (this.responsiveBg.length < 1) {
            return;
        }

        for (let i = 0; i < this.responsiveBg.length; i++) {
            const desktopImg = this.responsiveBg[i].dataset.desktopBackground;
            const mobileImg = this.responsiveBg[i].dataset.mobileBackground;

            if (this.checkWindowWidth() <= 1024) {
                this.responsiveBg[i].style.backgroundImage = mobileImg;
            } else {
                this.responsiveBg[i].style.backgroundImage = desktopImg;
            }

        }

    }

    checkWindowWidth() {
        let w;
        if (window.innerWidth !== undefined) {
            w = window.innerWidth;
        } else {
            w = document.documentElement.clientWidth;
        }
        return w;
    }

}
